<mat-toolbar color="accent">Create Brand</mat-toolbar>

<div class="layout-padding">
  <form fxLayout="column" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
    >
      Create
    </button>
  </form>
</div>
